<script lang="ts">
	import Faq from './ui/Faq.svelte';
	import Features from './ui/Features.svelte';
	import Hero from './ui/Hero.svelte';
	import Howitworks from './ui/Howitworks.svelte';
</script>

<div class="flex w-full flex-col items-center space-y-24 pb-12 sm:space-y-36 sm:pb-20">
	<Hero />
	<Features />
	<Howitworks />
	<Faq />
</div>

<style>
</style>
